/**
 * Schema of Carga
 * @author Simpli CLI generator
 */
import {$, cep, phone, bool, cpfOrCnpj, datetime, InputType, Schema, cnpj} from 'simpli-web-sdk'
import * as Helpers from '@/helpers'
import moment from 'moment'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import CargaPedidoNroFiscal from '@/model/resource/CargaPedidoNroFiscal'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import RenderNumber from '@/components/render/RenderNumber.vue'
import {datetimeForCsv} from '@/helpers'

export default (model: CargaPedidoNroFiscal): Schema => ({
  nroNotaFiscalAlt: {
    content: model.nroNotaFiscal || '',
    textContent: model.nroNotaFiscal || '',
  },

  nroNotaFiscal: {
    content: [
      model.nroNotaFiscal,
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('nroNotaFiscal'),
          value: model.nroNotaFiscal,
        },
      },
      model.nroNotaFiscal,
    ],
    textContent: null,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  xpedido: {
    content: model.xpedido || '',
    textContent: model.xpedido || '',
    input: InputType.MASK,
    meta: {
      mask: '##########',
    },
  },
})
